<template>
  <div class="video">
    <div id="video" class="anchor"></div>
    <div class="enterprise-title">
      视频学习
      <lr-link @click="reportClick('more')" :to="moreVideoUrl"
        >查看更多></lr-link
      >
    </div>
    <div class="video-product">
      <lr-link
        class="product-card"
        :to="item.url"
        v-for="(item, index) in product"
        :key="index"
        @click="reportClick('introduction', item.id)"
        @mouseover="handleHoverProduct(index)"
        @mouseleave.native="handleUnhoverProduct()"
      >
        <div class="product-card-body">
          <img :src="productImg(index)" />
        </div>
        <div class="product-card-play" v-show="index === productHover"></div>
        <div class="product-card-boot">
          <h3>{{ item.title }}</h3>
          <p>
            {{ item.content }}
          </p>
        </div>
      </lr-link>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    product: {
      type: Array,
      default: () => [
        {
          title: 'WPS 2016介绍',
          content:
            '该课程讲解WPS2016在工作中的应用，课程分为WPS文字、WPS表格、WPS演示三大组件。',
          url: 'https://www.wps.cn/learning/enterprise/detail/id/13575.html',
          id: '13575',
        }
      ],
    },
  },
  data() {
    return {
      productHover: -1,
      moreVideoUrl: 'https://www.wps.cn/learning/enterprise/index.html',
    };
  },
  methods: {
    productImg(img) {
      return require(`@/assets/image/enterprise/video/product/introduce_${img}.png`);
    },
    handleHoverProduct(index) {
      this.productHover = index;
    },
    handleUnhoverProduct() {
      this.productHover = -1;
    },
    reportClick(click, id = null) {
      if (id) {
        this.$collect.enterpriseHomepageClick({ click, area: 'video', type:id });
      } else {
        this.$collect.enterpriseHomepageClick({ click, area: 'video' });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.video {
  &-title {
    color: black;
    font-size: 24px;
    font-weight: bold;
    padding: 60px 0 30px;
    user-select: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > a {
      font-size: 14px;
      font-weight: 400;
      color: #222226;
      &:hover {
        color: #417ff9;
      }
    }
    &-select {
      color: #417ff9 !important;
      border-bottom: 2px solid #417ff9;
    }
    > div {
      display: flex;
      align-items: center;
      > span {
        margin-left: 30px;
        font-size: 14px;
        font-weight: 400;
        color: #888888;
        display: inline-block;

        &:hover {
          color: #417ff9;
          cursor: pointer;
          border-bottom: 2px solid #417ff9;
        }
      }
    }
  }

  &-product {
    display: flex;
    justify-content: space-between;
    height: 388px;
  }

  &-cloud {
    display: flex;
    height: 388px;
    padding: 69px 0;
  }

  &-replay {
    display: flex;
    height: 388px;
    padding: 69px 0;
  }
}
.product {
  &-card {
    width: 357px;
    height: 388px;
    border-radius: 4px;
    border: 1px solid #e8e8e8;
    transition: box-shadow 0.4s;
    position: relative;

    &:hover {
      box-shadow: 2px 0 8px 4px rgba(44, 85, 166, 0.2);
    }

    &-body {
      width: 355px;
      height: 232px;
      > img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        border: 0;
      }
      > h3 {
        z-index: 1;
        max-width: 170px;
        max-height: 60px;
        font-size: 20px;
        font-weight: 700;
        line-height: 1.5;
        color: #4f26ef;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }

    &-play {
      position: absolute;
      top: 0;
      left: 0;
      width: 355px;
      height: 232px;
      background-color: rgba(0, 0, 0, 0.39);
      background-image: url('../../../assets/image/enterprise/video/product/ic_play.png');
      background-repeat: no-repeat;
      background-size: 60px 60px;
      background-position: center center;
    }

    &-boot {
      text-align: center;
      > h3 {
        margin: 30px 20px 20px;
        font-size: 18px;
        font-weight: 700;
        color: #313131;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      > p {
        margin: 0 20px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        font-size: 14px;
        color: #555;
        line-height: 28px;
      }
    }
  }
}
</style>
